/**
 * Created by
 * @author <yunishev@sotal.tv> Art Yunishev
 * on 12.05.2016.
 */
import {normalize, Schema, arrayOf} from 'normalizr';

import {GetUser} from '../../utils';
import {GetBookmark} from '../common/actions-common';

import _get from 'lodash/get';
import _concat from 'lodash/concat';

export const FETCH_ASSET = 'fetch-asset';
export const FETCH_ASSET_BY_IDS = 'fetch-assets-by-ids';

const asset = new Schema('asset');

export function FetchAssetById(id, opt_type) {
  let Q;
  let optSelect = [
    lh.models.asset.schema.id,
    lh.models.asset.schema.ratings,
    lh.models.asset.schema.has_adult_content,
    lh.models.asset.schema.resources,
    lh.models.asset.schema.title,
    lh.models.asset.schema.description,
    lh.models.asset.schema.duration,
    lh.models.asset.schema.year,
    lh.models.asset.schema.offers,
    lh.models.asset.schema.package_id,
    lh.models.channelAsset.schema.channel_type,
    lh.models.channelAsset.schema.er_lcn,
    lh.models.viewAsset.schema.package_type,
    lh.models.viewAsset.schema.tv_series_seasons
  ];

  Q = lh.asset.getAssetById(id, optSelect);

  return {
    type: FETCH_ASSET,
    meta: {key: id},
    payload: Q.then((asset) => {
      if (asset && asset.type === 'package' && asset.package_type === 'generic') {

        return lh.asset.getAssetsByIds(asset.assets || [], {
          select: [
            lh.models.asset.schema.id,
            lh.models.asset.schema.title,
            lh.models.asset.schema.type
          ],
          filters: [
            lh.models.asset.accessor.package_id.eq(asset.id)
          ]
        }).then((collection) => {
          asset._assets2 = collection;

          return asset;
        });
      } else if (asset && GetUser().user !== 'guest' && _get(Config, 'bookmark_allowed', false) && ['movie', 'episode'].indexOf(asset.type) !== -1) {

        return GetBookmark(id).payload
          .then((position) => {
            asset.is_bookmark = !!position && position > 0;
            asset.bookmark = position;

            return asset;
          });
      }

      return asset;
    })
  }
}

export function FetchAssetByIds(ids, opt) {
  let Q;

  if (!opt) opt = {};
  if (opt.select) {
    opt.select = _concat(opt.select, [
      lh.models.asset.schema.id,
      lh.models.asset.schema.has_adult_content,
      lh.models.asset.schema.ratings,
      lh.models.asset.schema.resources,
      lh.models.asset.schema.title,
      lh.models.asset.schema.description,
      lh.models.asset.schema.duration,
      lh.models.asset.schema.year,
      lh.models.asset.schema.offers,
      lh.models.asset.schema.package_id,
      lh.models.channelAsset.schema.channel_type,
      lh.models.channelAsset.schema.er_lcn,
      lh.models.viewAsset.schema.package_type,
      lh.models.viewAsset.schema.tv_series_seasons
    ]);
  } else {
    opt.select = [
      lh.models.asset.schema.id,
      lh.models.asset.schema.has_adult_content,
      lh.models.asset.schema.ratings,
      lh.models.asset.schema.resources,
      lh.models.asset.schema.title,
      lh.models.asset.schema.description,
      lh.models.asset.schema.duration,
      lh.models.asset.schema.year,
      lh.models.asset.schema.offers,
      lh.models.asset.schema.package_id,
      lh.models.channelAsset.schema.channel_type,
      lh.models.channelAsset.schema.er_lcn,
      lh.models.viewAsset.schema.package_type,
      lh.models.viewAsset.schema.tv_series_seasons
    ];
  }

  Q = lh.asset.getAssetsByIds(ids, opt);

  return {
    type: FETCH_ASSET_BY_IDS,
    payload: Q.then((collection) => {

      let normalizedSchedule = normalize(collection, arrayOf(asset));

      return normalizedSchedule;
    })
  }
}



// WEBPACK FOOTER //
// ./src/actions/asset/action-asset.js